import type { Toast } from '@/models/Toast';

import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useToastStore = defineStore('toast', () => {
  const toast = ref<Toast | null>(null);

  const showToast = (newToast: Toast) => {
    clearToast();

    toast.value = newToast;
  };

  const clearToast = () => {
    toast.value = null;
  };

  return {
    toast,
    showToast,
    clearToast,
  };
});
